import React from 'react';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { LeftContent } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, ConnectButton, RightForm } from 'components/Dialog/DialogRightContent';
import { ErrorMessage, Input, InputGrid } from 'components/Form';
import { SubmitHandler, useForm } from 'react-hook-form';
import { shopifyAuthorize } from 'api/webstore';
import { useAppStore } from 'stores/appStore';
import { DialogProps } from 'interfaces/Props';
import { showAlert } from 'components/Alert';
import { channels } from 'shared/constants';

import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import WarningIcon from '@mui/icons-material/Warning';
import config from 'config';

interface FormValues {
  store_name: string;
  webstore_url: string;
  client_id: string;
  client_secret: string;
}

const ShopifyContent: React.FunctionComponent<DialogProps> = ({ handleClosePrimary, getListChannel }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = async (formData) => {
    try {
      const res = await shopifyAuthorize(formData.webstore_url, formData.client_id, formData.client_secret);

      if (res?.data?.status === 'ok' && res?.data?.redirect) {
        window.location.href = res?.data?.redirect;
      } else {
        showAlert('error', `${res?.data?.message}`, 5000);
      }
    } catch (err) {
      const error = err as Error;
      console.error(error);
      showAlert('error', `${error}`, 5000);
    }
  };

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <LeftContent channelId={channels.SHOPIFY} />
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="shopify_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            wide={true}
            label={<Label className="requiredField">Nama Toko</Label>}
            input={
              <Input
                isError={errors.store_name?.message ? true : false}
                type={'text'}
                placeholder={'Masukkan Nama Toko'}
                {...register('store_name', {
                  required: { value: true, message: 'Nama Toko harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.store_name && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.store_name.message}
                />
              )
            }
          />
          <InputGrid
            wide={true}
            label={<Label className="requiredField">Alamat Webstore</Label>}
            input={
              <Input
                isError={errors.webstore_url?.message ? true : false}
                type={'text'}
                placeholder={'Masukkan Alamat Webstore'}
                {...register('webstore_url', {
                  required: { value: true, message: 'Alamat Webstore harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.webstore_url && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.webstore_url.message}
                />
              )
            }
          />
          <InputGrid
            wide={true}
            label={<Label className="requiredField">Client ID</Label>}
            input={
              <Input
                isError={errors.client_id?.message ? true : false}
                type={'text'}
                placeholder={'Client ID'}
                {...register('client_id', {
                  required: { value: true, message: 'Client ID harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.client_id && (
                <ErrorMessage icon={<WarningIcon fontSize="small" color="error" />} message={errors.client_id.message} />
              )
            }
          />
          <InputGrid
            wide={true}
            label={<Label className="requiredField">Client Secret</Label>}
            input={
              <Input
                isError={errors.client_secret?.message ? true : false}
                type={'text'}
                placeholder={'Client Secret'}
                {...register('client_secret', {
                  required: { value: true, message: 'Client Secret harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.client_secret && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.client_secret.message}
                />
              )
            }
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ConnectButton form="shopify_form">Sambungkan</ConnectButton>
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default ShopifyContent;
